import { render, staticRenderFns } from "./qiangzhiDialog.vue?vue&type=template&id=530c0146&scoped=true"
import script from "./qiangzhiDialog.vue?vue&type=script&lang=js"
export * from "./qiangzhiDialog.vue?vue&type=script&lang=js"
import style0 from "./qiangzhiDialog.vue?vue&type=style&index=0&id=530c0146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c0146",
  null
  
)

export default component.exports